export default __webpack_public_path__ + "static/media/m_ceoLanding06.0f296d95.png";